import React from 'react';

const BrandTable = () => {
    return (
        <div> </div>
    );
};

export default BrandTable;